import { observer } from "mobx-react-lite";
import React from "react";
import { TicketMetaField } from "../../../../..";
import { ClassNameFieldExtensions } from "../../../../../types/field_configs/Meta";
import { OD3_SourceConfig } from "./OD3_SourceConfig";

type Props = {
  field: TicketMetaField & { type: "select_parse" };
  name?: string;
};

const ParseSelectSpecificOptionsMap: {
  [K in keyof Partial<ClassNameFieldExtensions>]: React.FC<
    Props & { field: Extract<TicketMetaField, { className: K }> }
  >;
} = {
  OD3_Source: OD3_SourceConfig as React.FC<
    Props & { field: Extract<TicketMetaField, { className: "OD3_Source" }> }
  >,
};

export const ParseSelectSpecificOptions = observer((props: Props) => {
  const SpecificOption = ParseSelectSpecificOptionsMap[props.field.className];
  return <>{SpecificOption && <SpecificOption field={props.field} />}</>;
});
